import { modifier } from 'ember-modifier';

export default modifier(
  function removeNotificationAfterTime(element, positional /* named*/) {
    const notification = positional[0];
    setTimeout(() => {
      element.remove();
    }, notification.timeout);
  }
);
